import React from "react";

import { MAX_RATING } from "../reviewsService";
import { ratingLabel } from "../reviewsMappers";

const STEPS = Array.from({ length: MAX_RATING }, (unused, index) => index + 1);

const StarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 3.1c.3 0 .58.17.72.45l2.36 4.78 5.28.77c.62.09.87.85.42 1.29l-3.82 3.72.9 5.26a.8.8 0 0 1-1.17.84L12 17.72l-4.72 2.49a.8.8 0 0 1-1.17-.84l.9-5.26-3.82-3.72c-.45-.44-.2-1.2.42-1.29l5.28-.77 2.36-4.78c.14-.28.42-.45.72-.45Z" />
  </svg>
);

export const StarRow = ({ rating, size = "md" }) => {
  const value = Number(rating) || 0;

  return (
    <span className={`rv-stars rv-stars-${size}`} aria-label={`${ratingLabel(value)} out of 5`}>
      {STEPS.map((step) => {
        const fill = Math.min(1, Math.max(0, value - step + 1));

        return (
          <span key={step} className="rv-star">
            <StarIcon className="rv-star-track" />

            <span className="rv-star-fill" style={{ width: `${fill * 100}%` }}>
              <StarIcon />
            </span>
          </span>
        );
      })}
    </span>
  );
};

export const RatingLine = ({ rating, size = "md" }) => (
  <span className="rv-rating-line">
    <StarRow rating={rating} size={size} />
    <b>{ratingLabel(rating)}</b>
  </span>
);

export const StarInput = ({ value, onChange, label = "Your rating" }) => (
  <div className="rv-star-input" role="radiogroup" aria-label={label}>
    {STEPS.map((step) => (
      <button
        key={step}
        type="button"
        role="radio"
        aria-checked={value === step}
        aria-label={`${step} ${step === 1 ? "star" : "stars"}`}
        className={`rv-star-btn${step <= value ? " is-on" : ""}`}
        onClick={() => onChange(step)}
      >
        <StarIcon />
      </button>
    ))}
  </div>
);

export default StarRow;
